import styled from 'styled-components';
import { Card } from 'antd';
import { COLORS } from '@/theme';

export const InspectorCard = styled(Card)`
  border: 1px solid ${COLORS.GRAY_94};
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.1);

  & > .ant-card-head {
    min-height: 48px;
    padding: 0 16px;
    border-bottom: 2px solid rgba(22, 119, 255, 0.45);
    background: linear-gradient(180deg, #eef4ff 0%, #ffffff 100%);
  }

  & > .ant-card-head-title {
    font-weight: 700;
    font-size: 15px;
    letter-spacing: 0.03em;
    color: ${COLORS.BLACK_PRIMARY};
    padding: 12px 0;
  }

  & > .ant-card-body {
    padding: 16px;
    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 32px);
    border-radius: 0 0 8px 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.04);
  }
`;
